const PLAN_FEATURES = [
  "One active title",
  "Unlimited 4K renders",
  "All broadcast frame rates",
  "Scrolling credits + end cards",
  "Custom font & logo storage",
];

const EMPTY_PLAN = {
  isActive: false,
  isCancelled: false,
  planName: "No Active Plan",
  subscriptionState: "No Active Plan",
  billingCycle: "—",
  paymentLabel: "Next Payment",
  paymentDate: null,
  amount: null,
  entitlements: [],
};

function addInterval(start, intervalCount, interval) {
  if (!start) return null;
  const next = new Date(start);
  if (Number.isNaN(next.getTime())) return null;
  const count = Number(intervalCount) || 0;
  switch (interval) {
    case "day":
      next.setDate(next.getDate() + count);
      break;
    case "week":
      next.setDate(next.getDate() + count * 7);
      break;
    case "month":
      next.setMonth(next.getMonth() + count);
      break;
    case "year":
      next.setFullYear(next.getFullYear() + count);
      break;
    default:
      return null;
  }
  return next;
}

function resolveExpiry(plan) {
  if (plan?.expiry_date) {
    const serverDate = new Date(plan.expiry_date);
    if (!Number.isNaN(serverDate.getTime())) return serverDate;
  }
  const details = plan?.plan_detail;
  if (!details || !plan?.createdAt) return null;
  return addInterval(plan.createdAt, details.interval_count, details.interval);
}

function billingCycleLabel(details) {
  const interval = String(details?.interval || "").toLowerCase();
  const count = Number(details?.interval_count);
  if (interval === "week" || interval === "weekly" || count === 7) return "Weekly";
  if (interval === "month" || interval === "monthly" || count === 30) return "Monthly";
  if (interval === "year" || interval === "yearly" || count === 365) return "Yearly";
  return "—";
}

/**
 * Billing card state from getUserPlan.
 * An active plan needs plan details, isExpired !== true, and an expiry still ahead.
 * Cancelled (2) or deleted (0) access stays until that expiry, without a next charge.
 */
export function getBillingPlanView(currentPlan, now = new Date()) {
  const plan = currentPlan?.plan;
  const details = plan?.plan_detail || null;
  const expiry = resolveExpiry(plan);
  const expiryValid = expiry && !Number.isNaN(expiry.getTime());
  const serverExpired = currentPlan?.isExpired === true;
  const withinWindow = expiryValid && now.getTime() < expiry.getTime();
  const isActive = Boolean(details) && !serverExpired && withinWindow;

  if (!isActive) return EMPTY_PLAN;

  const willRenew =
    plan.subscription_status !== 2 && plan.subscription_status !== 0;
  const isCancelled = !willRenew;
  const type = String(details.type || "").trim();
  const price = Number(details.price);

  return {
    isActive: true,
    isCancelled,
    planName: type ? `${type} Plan` : "Current Plan",
    subscriptionState: isCancelled ? "Cancelled" : "Active Subscription",
    billingCycle: billingCycleLabel(details),
    paymentLabel: isCancelled ? "Expires" : "Next Payment",
    paymentDate: expiry,
    amount: !isCancelled && price > 0 ? price : null,
    entitlements: PLAN_FEATURES,
  };
}
